import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { Tabs, Tab } from '@material-ui/core';
import { EventType } from '../../models/EventType';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { SPORTS_ICONS } from '../../constants/SportsNavView';
import { getCurrencyTypeFromToken } from '../../store';
import { RootState } from '../../models/RootState';
import { setEventType, fetchCompetitions, setCompetition } from '../../store';
import InplayImg from '../../assets/images/sportsbook/icons/inplay.svg';
import CasinoImg from '../../assets/images/sportsbook/icons/casino.svg';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { IonIcon } from '@ionic/react';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import Dialog from '@material-ui/core/Dialog';
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import ClearIcon from '@material-ui/icons/Clear';
import './ExchangeSportsListNav.scss';
import { BBL_CUP, IPL_CUP, WORLD_CUP } from '../../constants/IPLEvent';
import { ReactComponent as IPLCup } from '../../assets/images/common/ipl-trophy.svg';
import { ReactComponent as WORLDCUP } from '../../assets/images/common/trophy.svg';
import { BRAND_NAME } from '../../constants/Branding';

type PropType = {
  eventTypes: EventType[];
  selectedEventType: SelectedObj;
  allowedConfig: number;
  setEventType: (eventType: SelectedObj) => void;
  setCompetition: (eventType: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
};

const ExchangeSportsListNav: React.FC<PropType> = (props) => {
  const {
    eventTypes,
    selectedEventType,
    allowedConfig,
    setEventType,
    setCompetition,
    fetchCompetitions,
  } = props;
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [gameId, setGameId] = useState<String>('');
  const [gameName, setGameName] = useState<String>('');
  const [gameCode, setGameCode] = useState<String>('');
  const [provider, setProvider] = useState<String>('');
  const [subProvider, setSubProvider] = useState<String>('');
  const [tabValue, setTabValue] = useState<number>(0);
  const [open, setOpen] = React.useState<boolean>(false);
  const history = useHistory();
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleSportChange = (sport) => {
    if (sport.id === '6' || sport.id === '7') return;
    setCompetition({ id: '', name: '', slug: '' });
    setEventType({ id: sport.id, name: sport.name, slug: sport.slug });
    fetchCompetitions(sport.id);
  };

  useEffect(() => {
    for (let i = 0; i < eventTypes.length; i += 1) {
      if (eventTypes[i].slug === selectedEventType.slug) {
        setTabValue(i);
        break;
      }
    }
  }, [selectedEventType, eventTypes]);
  const closeDialog = async () => {
    await setOpenDialog(false);
    getGameUrl(
      gameId?.toString(),
      gameName?.toString(),
      gameCode?.toString(),
      provider?.toString(),
      subProvider?.toString()
    );
  };
  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    history.push(
      `/gap_casino/game/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
        gameId.toString()
      )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
    );
  };
  const pathParams = useParams();
  const eventType = pathParams['eventType'];
  return (
    <>
      <div className="exch-sports-nav-list">
        <Tabs
          className="exch-sports-list"
          value={tabValue}
          onChange={handleTabChange}
          // variant="scrollable"
          // scrollButtons="auto"
        >
          {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <NavLink className="nav-link tab" to="/exchange_sports/inplay">
              <Tab
                className="sport-name"
                label="InPlay"
                icon={
                  <img className="sport-icon2" alt="inPlay" src={InplayImg} />
                }
                wrapped
              />
            </NavLink>
          ) : null}

          {/* {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <>
              <NavLink
                className="nav-link tab1"
                to={`/exchange_sports/cricket/icc-world-cup-t20-2024/icc-world-cup-t20-2024/${btoa(
                  WORLD_CUP.routeHash
                )}`}
              >
                <Tab
                  className="sport-name"
                  label="Men's WORLD Cup"
                  icon={<WORLDCUP className="sport-icon2 light-svg-color" />}
                  wrapped
                />
              </NavLink>
            </>
          ) : null} */}

          {eventTypes.map((sport, index) => {
            return (
              <NavLink
                className={
                  sport.id == '6' || sport.id === '7'
                    ? 'nav-link tab1'
                    : 'nav-link tab'
                }
                key={sport?.slug + sport?.name + index}
                onClick={() => handleSportChange(sport)}
                to={`/exchange_sports/${sport?.slug}`}
              >
                <Tab
                  label={sport?.name}
                  icon={
                    <IonIcon
                      className={`sport-icon${index}`}
                      key={`sport-icon${index}`}
                      src={
                        SPORTS_ICONS[sport?.name]
                          ? SPORTS_ICONS[sport?.name]
                          : SPORTS_ICONS['Other']
                      }
                    />
                  }
                  value={index}
                  wrapped
                />
              </NavLink>
            );
          })}

          {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 &&
          ALLOW_CASINO ? (
            <NavLink className="nav-link tab" to="/casino">
              <Tab
                className="sport-name"
                label="Casino"
                icon={<img className="sport-icon" src={CasinoImg} alt="live" />}
                value={eventTypes.length + 2}
                wrapped
              />
            </NavLink>
          ) : null}
        </Tabs>
      </div>

      <Dialog
        open={openDialog}
        onClose={() => closeDialog()}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="go-corner" onClick={() => closeDialog()}>
            <div className="go-arrow">
              <ClearIcon />
            </div>
          </div>

          <div className="dialog-title">
            <StarBorderRoundedIcon />
            Welcome
            <StarBorderRoundedIcon />
          </div>

          {getCurrencyTypeFromToken() === 0 ? (
            <div className="dialog-body">
              1 Live casino point is equal to 100 normal points
              <div className="dialog-ex">
                {' '}
                Ex: 100 casino points = 10000 normal points
              </div>
              <p className="dialog-ex">
                Maximum Bet limit is 5000 casino points
              </p>
            </div>
          ) : null}

          {getCurrencyTypeFromToken() === 1 ? (
            <>
              {' '}
              <div className="dialog-body">
                <div className="dialog-ex">
                  {' '}
                  Maximum Bet Limit For All Games is 5000
                </div>
              </div>
            </>
          ) : null}
          <div className="dialog-continue" onClick={() => closeDialog()}>
            <div className="custom-btn btn">Continue</div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    selectedEventType: state.exchangeSports.selectedEventType,
    allowedConfig: state.common.allowedConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setEventType: (eventType: SelectedObj) => dispatch(setEventType(eventType)),
    setCompetition: (eventType: SelectedObj) =>
      dispatch(setCompetition(eventType)),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchangeSportsListNav);
